/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
declare var require: any;

export namespace userTypes {
  export enum USER_GROUPS {
    upUNK = 0,
    upDAD = 77,
    upRT = 72,
    upGRT = 71,
    upAD = 70,
    upPROV = 30,
    upHIE = 31,
    upNP = 32,
    upN = 33,
    upRCPT = 34,
    upMA = 35,
    upOMGR = 36,
    upBL = 20,
    upPTC = 10,
    upPHR = 11,
    upSCH = 12,
    upTECH = 13,
    upHIT = 14,
    upISO = 15,
    upVEN = 16,
    upPYR = 17,
    upPHARM = 18,
  };

  export enum USER_FEATURES {
    ufNone = 0,
    ufUserAdministrator = 1,
    ufBackup = 2,
    ufImport = 3,
    ufExport = 4,
    ufICEMEDXFormTemplates = 5,
    ufFormTemplates = 6,
    ufOtherItemsSoldandServices = 7,
    ufOtherItemReceiving = 8,
    ufPayerSearch = 9,
    ufSetup = 10,
    ufProviderSearch = 11,
    ufEHRDataTypes = 12,
    ufSubscriptionPurchase = 13,
    ufCPTSearch = 14,
    ufICDSearch = 15,
    ufSuperBill = 16,
    ufSalesTax = 17,
    ufMedicalServiceCharges = 18,
    ufAccountingJournals = 19,
    ufSchedule = 20,
    ufOptions = 22,
    ufCombineCharts = 23,
    ufAuditTrail = 24,
    ufX12NSearch = 25,
    ufNDCSearch = 26,
    ufManagementGuidelineSearch = 27,
    ufAlerts = 28,
    ufCommonFormTemplates = 29,
    ufCreditCardMerchant = 30,
    ufCheckMerchant = 31,
    ufFavoriteSearch = 32,
    ufDemonstration = 33,
    ufDispensing = 34,
    ufClinicalNotes = 35,
    ufIdentification = 36,

    ufPMS = 100,
    ufEHR = 101,
    ufPHR = 102,
    ufPHI = 103,
    ufMerchantProcessor = 104,
    ufClearingHouse = 105,

    ufDemographics = 110,
    ufContactAndAddress = 111,
    ufInsuranceSubscriber = 112,
    ufRelativesAndFriends = 113,
    ufPatientProviderList = 114,
    ufDiagnosis = 115,
    ufVitals = 116,
    ufMedication = 117,
    ufReserved1 = 118,
    ufEncounters = 119,
    ufExternalDocuments = 120,
    ufMiscellaneousForms = 121,
    ufAllergies = 122,
    ufTreatmentPlans = 123,
    ufOrders = 124,
    ufReports = 125,

    ufProfessionalClaims = 200,
    ufDentalClaims = 201,
    ufInstitutionalClaims = 202,

    ufReferrals = 205,
    ufEligibilityBenefitInquiry = 206,
    ufERA = 207,
    ufRetailPrescription = 208,
  }

  export enum USER_FEATURE_ACCESS {
    ufaNone = 0,
    ufaReadOnly = 1,
    ufaAdd = 2,
    ufaRemove = 3,
    ufaFullControl = 5,
  }
}
export class LoginConfig {

    public networknowehr_hostname = location.hostname;
    public networknowehr_port = location.port;
    public networknowehr_hostprotocol = location.protocol;
    public app_path = "";
    public networknowehrapp = this.networknowehr_hostprotocol + '//' + this.networknowehr_hostname + (this.networknowehr_port.length > 0 ? ":" + this.networknowehr_port : "") + '/';

    public client_id = 'ICE1';
    public client_s = 'df19a420206de249d6f79dae219569a1b2b001d325a98791';

  public whitelabel_brand = null;
    public defaultresource_token_scope = "";
    public identity_server = "";
    public identity_service = "";
    public identity_signoutUri = "";

    public identity_authorizeUri = "";
    public identity_registrationUri = "";
  public identity_wlRegistrationUri = "";
    public identity_tokenUri = "";
    public identity_redirectUrl: string = "";
    public identity_ui_signoutUri = "";
    public identity_token_scope = "";
    public identity_signerRedirectUrl: string = "";

    public identity_userInfoUri: string = "";
    public identity_userLogsUri: string = "";
    public identity_notificationsUri = "";

    public identity_UserProfileUri = "";
    public identity_DoLoginUri = "";
    public identity_messagesUri = "";
    public identity_loginCompleteUri = "";

    public identity_verifyRecaptchaUri: string = "";
    public identity_PrivateNetworkUri: string = "";
    public identity_RegisterMemberUri: string = "";

  currentDateFormat: string = "MM/dd/yyyy";
  currentLocale: string = "en-US";

    constructor() {
        let currentEnv: any = require("../../../../env.json").currentEnv;
        let envs: any = require("../../../../env.json").environments;
        if (!envs || !currentEnv) throw "Login service is not configured.";

        this.app_path = envs[currentEnv].app_path;
        this.defaultresource_token_scope = envs[currentEnv].icemedx_api;
        this.identity_server = envs[currentEnv].login_server;
        this.identity_service = envs[currentEnv].login_path;

        this.identity_server = this.identity_server + this.identity_service;
        this.identity_signoutUri = this.identity_server + 'api/OAuth/Logout';

        this.identity_authorizeUri = this.identity_server + 'ClientOAuth/Authorize';
        this.identity_registrationUri = this.identity_server + 'ClientOAuth/Register';
        this.identity_wlRegistrationUri = this.identity_server + 'ClientOAuth/WLRegister';
        this.identity_tokenUri = this.identity_server + 'ClientOAuth/Token';
      this.identity_redirectUrl = this.networknowehrapp + LoginConfig.getFormattedPath(this.networknowehr_hostname.indexOf("localhost") < 0 ? "wapp/" : this.app_path, 'logincallback');
      this.identity_signerRedirectUrl = this.networknowehrapp + LoginConfig.getFormattedPath(this.networknowehr_hostname.indexOf("localhost") < 0 ? "wapp/" : this.app_path, 'signercallback');
        this.identity_ui_signoutUri = this.identity_server + 'ClientOAuth/LogoutLogin';
        this.identity_token_scope = this.defaultresource_token_scope;

        this.identity_userInfoUri = this.identity_server + 'api/OAuth/UserInfo';
        this.identity_userLogsUri = this.identity_server + 'api/OAuth/UserLogs';
        this.identity_notificationsUri = this.identity_server + 'api/OAuth/Notifications';

        this.identity_UserProfileUri = this.identity_server + 'Home/UserProfile';
        this.identity_DoLoginUri = this.identity_server + 'ClientOAuth/DoLogin';
        this.identity_messagesUri = this.identity_server + 'Notifications';

        this.identity_verifyRecaptchaUri = this.identity_server + 'api/OAuth/VerifyRecaptcha';
        this.identity_PrivateNetworkUri = this.identity_server + 'DomainAccess/PrivateNetwork';

        this.identity_RegisterMemberUri = this.identity_server + 'ClientOAuth/RegisterToDomain' + "?returnurl=%2fclientoauth%2fauthorize%3fclient_id%3d" + this.client_id + "%26redirect_uri%3d" + encodeURIComponent(this.identity_redirectUrl) + "%26state%3didentity%26scope%3d" + encodeURIComponent(this.defaultresource_token_scope) + "%26response_type%3dcode";
      this.whitelabel_brand = envs[currentEnv].whitelabel_brand;
    }

  public static getFormattedPath(appPath: string, routeName: string, addSlash?: boolean) {
    if (routeName == null || routeName == "") return "";

    let slash: string = addSlash == true ? '/' : '';
	  if (appPath == "/" && addSlash != true) appPath = appPath.replace("/", "");
    return appPath == "" || appPath == null ? (slash + routeName) : appPath + routeName;
  }

  getCurrentDateFormat(): string {
    return this.currentDateFormat;
  }
}
